<template>
  <modal :show="isModalVisible" @close="isModalVisible = false" class="prompt-modal" :persist="true">
    <form @submit.prevent="confirmPractice">
      <div class="modal-header">
        <h3 class="m-0">Please {{ isPracticeComplete ? 'confirm' : 'complete' }} your practice</h3>
      </div>
      <div class="modal-body d-flex">
        <div v-if="!isEditView">
          <p class="lead" style="max-width: 500px">
            We surface this information to referring offices and patients. You can change it later at anytime.
          </p>
          <div class="alert alert-muted" style="font-size: 1.35em">
            <b>{{ practice.name }}</b>
            <address v-if="practice.address" v-html="$helpers.address(practice, '<br />')"></address>
            <i v-else class="d-block text-hint">No address information</i>
            <p class="m-0" v-if="practice.phone">
              {{ practice.phone | phone }}
            </p>
            <!-- <p class="m-0" v-if="practice.fax">
            Fax: {{ practice.fax | phone }}
          </p> -->
          </div>
          <div class="d-flex flex-column justify-content-end m-0">
            <div class="">
              <small class="text-muted">
                By continuing you agree to the
                <router-link to="/privacy-policy" target="_blank">Privacy Policy</router-link>,
                <router-link to="/terms-of-use" target="_blank">Terms of Use</router-link>
                and
                <router-link to="/business-agreement" target="_blank">Business Associate Agreement</router-link>
              </small>
            </div>
          </div>
        </div>
        <div v-else style="width: 350px; max-width: 450px">
          <div class="form-group">
            <label>Practice Name</label>
            <input
              v-model="practice.name"
              type="text"
              class="form-control form-control-lg"
              placeholder="Practice Name"
              required
              v-validate
              name="name"
            />
          </div>
          <div class="form-group">
            <label>Office Address</label>
            <div class="d-flex flex-row align-items-center">
              <div class="flex-grow-1 autocomplete-lg w-100">
                <autocomplete
                  @selected="addressSelected"
                  :value="
                    practice.address
                      ? [practice.address, practice.address_2, practice.city, practice.state]
                          .filter((s) => s)
                          .join(', ')
                      : null
                  "
                />
              </div>
            </div>
          </div>

          <div class="form-group">
            <label>Office Phone</label>
            <cleave
              v-model="practice.phone"
              :options="cleave.phone"
              class="form-control form-control-lg"
              placeholder="Office Phone Number"
              v-validate
              required
              name="Phone"
            ></cleave>
          </div>
          <div class="form-group" v-if="practice.fax">
            <label>Office Fax</label>
            <cleave
              v-model="practice.fax"
              :options="cleave.phone"
              class="form-control form-control-lg"
              placeholder="Office Fax Number"
            ></cleave>
          </div>
          <div class="form-group" v-if="isEmailEditable">
            <label>Office Email</label>
            <input
              v-model="practice.email"
              type="email"
              class="form-control form-control-lg"
              placeholder="Practice Email"
              required
              v-validate
              data-vv-as="email"
              name="email"
            />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-lg btn-xl btn-primary btn-block m-0" :disabled="isSubmitting">
          <font-awesome-icon icon="spinner-third" v-if="isSubmitting" spin />
          <span v-else-if="!isEditView">I confirm, it's correct!</span>
          <span v-else>{{ btnEditText }}</span>
        </button>
        <a
          v-if="isPracticeComplete"
          href="javascript:;"
          class="btn btn-link btn-block font-weight-bolder mr-3"
          @click="isEditView = !isEditView"
          >{{ isEditView ? 'Cancel' : 'No, let me update it' }}</a
        >
      </div>
    </form>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import { mapState } from 'vuex'
import { PracticeApi } from '@/services'
import Autocomplete from '@/components/shared/address-lookup/Autocomplete'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
export default {
  components: { Modal, Autocomplete, Cleave },
  data() {
    return {
      isModalVisible: true,
      isSubmitting: false,
      isEditView: false,
      practice: { ...this.$store.state.auth.user.practice },
      cleave: {
        phone: { phone: true, phoneRegionCode: 'us' },
      },
      isEmailEditable: true,
      btnEditText: "Now it's correct!",
    }
  },
  computed: {
    ...mapState('auth', ['user', 'token', 'error']),
    isPracticeComplete() {
      return this.practice.address && this.practice.phone && this.practice.email
    },
  },
  mounted() {
    if (!this.isPracticeComplete || !this.practice.email) {
      this.isEditView = true
      this.isEmailEditable = !this.practice.email
      this.btnEditText = 'Complete my practice'
    }
  },
  methods: {
    async confirmPractice() {
      const isValid = await this.$validator.validate()
      if (!isValid) return
      this.isSubmitting = true
      try {
        if (!this.practice.timezone) {
          this.practice.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        await this.$store.dispatch('practices/save', this.practice)
        await PracticeApi.saveRelated(this.practice.id, 'complete-setup', {}, { json: false })
        this.isModalVisible = false
        await this.$store.dispatch('practices/refreshCurrentUserPractice')
        await this.$store.dispatch('referrals/load', true)
      } catch (err) {
        this.$exception(err)
      }
      this.isSubmitting = false
    },
    addressSelected: function (address) {
      this.practice.address = address.address
      this.practice.address_2 = address.address_2
      this.practice.city = address.city
      this.practice.state = address.state
      this.practice.zip = address.zip
      this.practice.location = address.location
    },
  },
}
</script>
<style scoped lang="scss">
.prompt-modal .modal-container {
  width: 100%;
}
@media (min-width: 576px) {
  .prompt-modal .modal-container {
    width: 550px;
  }
}
</style>
